import React from 'react';
import Disclaimer from '../Disclaimer';
import { Row, Col } from '../../../base/Grid';
import Typography from '../../../base/Typography';

import { DisclaimerSectionStyled, DisclaimerColStyled } from './styles';

const DisclaimerSection = ({ isAmp, disclaimerFootnotes, customDisclaimers }) => (
  <DisclaimerSectionStyled>
    {(disclaimerFootnotes && disclaimerFootnotes.length > 0)
|| (customDisclaimers && customDisclaimers.length > 0) ? (
  /* If disclaimerFootnotes or customDisclaimer, then put custom content on left, stock disclaimer on right */
  <Row align='center'>
    <Col xsmall={12} medium={6}>
      {disclaimerFootnotes && disclaimerFootnotes.length > 0 && (
        <Row align='center'>
          <DisclaimerColStyled>
            {disclaimerFootnotes.map((disclaimerFootnote, index) => (
              <Typography component='p'
                className="footnote-item"
                disableBottomPadding={true}
                key={`disclaimer-footnote-${index}`}
              >
                <Typography component='small'>
                  {disclaimerFootnote}
                </Typography>
              </Typography>
            ))}
          </DisclaimerColStyled>
        </Row>
      )}

      {customDisclaimers && customDisclaimers.length > 0 && (
        <Row align='center'>
          <DisclaimerColStyled>
            {customDisclaimers.map((customDisclaimer, index) => (
              <Typography
                component='p'
                disableBottomPadding={true}
                key={`custom-disclaimer-footnote-${index}`}
              >
                <Typography component='small'>
                  {customDisclaimer}
                </Typography>
              </Typography>
            ))}
          </DisclaimerColStyled>
        </Row>
      )}
    </Col>
    <Col xsmall={12} medium={6}>
      <Disclaimer disclaimerFootnotes={disclaimerFootnotes} customDisclaimers={customDisclaimers} isAmp={isAmp} />
    </Col>
  </Row>
      ) : (
    /* Otherwise, let custom disclaimer span full-width broken up into 2 cols */
        <Row align='center'>
          <Disclaimer disclaimerFootnotes={disclaimerFootnotes} customDisclaimers={customDisclaimers} isAmp={isAmp} />
        </Row>
      )}
  </DisclaimerSectionStyled>
);

export default DisclaimerSection;
